module.exports = __webpack_public_path__ + "static/media/icon.facebook.8f10aced.svg";